import React from "react";

import { deleteSS, getSS, setSS } from '../../helpers'
import renewalDonationAmount from '../../data/renewalDonationAmount'

interface MembershipPlusProps {
  [key: string]: any
}

const MembershipPlus: React.FC<MembershipPlusProps> = (props:any) => {

  // const membership_form = (window as any).KEW.collections.membership_form[0]
  const [ donationAdded, setDonationAdded ] = React.useState(getSS('manualDonationAdded'));

  React.useEffect(() => {
    if (getSS('manualDonationAdded')) {
      props.setFieldValue('renewal_donation_added', renewalDonationAmount);
      setTimeout(() => {
        document.querySelector<HTMLButtonElement>('button.add')?.click()
      }, 50);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function addDonation(event: any, value: boolean) {
    // console.log(value)
    event.preventDefault();
    event.target.blur();
    setDonationAdded(value);
    if (value) {
      setSS('manualDonationAdded', value);
    } else {
      deleteSS('manualDonationAdded');
    }
    props.setFieldValue('renewal_donation_added', value ? renewalDonationAmount : 0);
  }

  return (
    <>
      <div>
        <div className="membership-plus clearfix box">
          <div className="small-12 columns">
            <div className="row intro-divider"></div>
          </div>
          <div className="medium-6 columns">
            <h2>Add a donation to your membership</h2>
            <p>As a charity, we rely on your vital support. By adding a donation to your membership, a £15 donation will be taken now and each time your membership is renewed. You'll be supporting our mission to protect global plant and fungal biodiversity for the future of all life on Earth. Thank you for adding a donation to your membership.</p>
            <div className="add-donation">
              <div className="donation-amount"><b>£{renewalDonationAmount.toFixed(2)}</b></div>
              <div className="donation-button">
                { donationAdded ? (
                  <>
                    {!props.topupDonation &&
                      <button aria-label="Remove donation" type="button" className="link remove" onClick={(e) => addDonation(e, false)}>
                        Remove
                      </button>
                    }
                    <button type="button" className="added btn-cta" tabIndex={-1}>
                      Added <img src="/assets/default/images/check.svg" alt="" width="16" height="16" />
                    </button>
                  </>
                ) : (
                  <button type="button" className="add btn-cta" onClick={(e) => addDonation(e, true)}>Add</button>
                )}
              </div>
            </div>
          </div>

          <div className="medium-6 columns">
            <img src="/assets/default/images/renewal_donation.jpg" alt="Planting trees" />
          </div>
        </div>
      </div>
    </>
  );
};

export default MembershipPlus;